import type { ActiveAssetKind } from '../pnid/activeAssetKind';

/**
 * Which saved marks the canvas draws.
 *
 * Every saved mark draws. Isolate narrows the drawing to the asset in hand:
 * the active equipment or line, as `activeKind` names, with its instruments.
 */
export function equipmentOverlayVisible(activeKind: ActiveAssetKind, isolating: boolean, isActive: boolean): boolean {
  return !isolating || (activeKind === 'equipment' && isActive);
}

export function nodeOverlayVisible(activeKind: ActiveAssetKind, isolating: boolean, isActive: boolean): boolean {
  return !isolating || (activeKind === 'line' && isActive);
}

/** `parentKind` is the kind of the instrument's parent. */
export function attachedInstrumentOverlayVisible(
  activeKind: ActiveAssetKind,
  isolating: boolean,
  parentKind: ActiveAssetKind,
  isOfActiveParent: boolean,
): boolean {
  return !isolating || (activeKind === parentKind && isOfActiveParent);
}

/** Nothing owns an unattached instrument, so Isolate hides it. */
export function unattachedInstrumentOverlayVisible(isolating: boolean): boolean {
  return !isolating;
}
